import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
export function LiveNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: 'Susana M.',
    city: 'Mar del Plata',
    product: 'Megapack + Protocolo Pro 🏆',
    time: 'hace 3 minutos'
  });
  const notifications = [{
    name: 'Susana M.',
    city: 'Mar del Plata',
    product: 'Megapack + Protocolo Pro 🏆',
    time: 'hace 3 minutos'
  }, {
    name: 'Carlos R.',
    city: 'Córdoba',
    product: 'Megapack Mente Viva 📘',
    time: 'hace 12 minutos'
  }, {
    name: 'María L.',
    city: 'Rosario',
    product: 'Megapack + Protocolo Pro 🏆',
    time: 'hace 25 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomNotif = notifications[Math.floor(Math.random() * notifications.length)];
        setNotification(randomNotif);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next
    }, 25000); // Show a new one every 25s
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-138">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white p-4 rounded-xl shadow-2xl border border-stone-200 max-w-xs w-full flex gap-3" data-id="element-139">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-140">
            <X className="w-4 h-4" data-id="element-141" />
          </button>

          <div className="mt-1" data-id="element-142">
            <CheckCircle className="w-6 h-6 text-blue-500" data-id="element-143" />
          </div>

          <div className="pr-4" data-id="element-144">
            <p className="text-xs font-bold text-blue-600 mb-1" data-id="element-145">
              🔔 NOTIFICACIÓN EN VIVO
            </p>
            <p className="text-sm text-slate-800 leading-tight mb-1" data-id="element-146">
              <span className="font-bold" data-id="element-147">{notification.name}</span> de{' '}
              {notification.city} compró{' '}
              <span className="font-medium" data-id="element-148">{notification.product}</span>
            </p>
            <p className="text-xs text-slate-500 flex items-center gap-1" data-id="element-149">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-150"></span>
              Compra verificada • {notification.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}